/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   Detail mlsData constants
 */

export const START_FETCHING_MLS_DATA = '@@nzr/Detail/START_FETCHING_MLS_DATA'
export const DONE_FETCHING_MLS_DATA = '@@nzr/Detail/DONE_FETCHING_MLS_DATA'
export const ERROR_FETCHING_MLS_DATA = '@@nzr/Detail/ERROR_FETCHING_MLS_DATA'
export const RECEIVE_MLS_DATA = '@@nzr/Detail/RECEIVE_MLS_DATA'
